import { css } from '@emotion/react';

export default () => css`
  .react-flow__node-default {
    padding: 0px;
    border: none;
  }
`;
